gsap.registerPlugin(TextPlugin);

const filterGroups = gsap.utils.toArray(".vertical-filter-block-group");
const expandFilterTriggers = gsap.utils.toArray(
  '[data-custom="exp-filter-top"]'
);
const animations = [];

filterGroups.forEach((filterGroup) => createAnimation(filterGroup));

expandFilterTriggers.forEach((filterBtn) => {
  filterBtn.addEventListener("click", () => toggleAnimation(filterBtn));
});

function toggleAnimation(expandFilterBtn) {
  // Save the current state of the clicked animation
  const selectedReversedState = expandFilterBtn.animation.reversed();

  // Play all animations
  animations.forEach((animation) => animation.play());

  // Set the reversed state of the clicked accordion element to the opposite of what it was before
  expandFilterTriggers.forEach((filterBtn) => {
    filterBtn.animation.reversed(!selectedReversedState);
  });
}

function createAnimation(element) {
  const expandFilterBtn = element.querySelector(
    '[data-custom="exp-filter-top"]'
  );
  const expandFilterBtnText = expandFilterBtn.querySelector(
    '[data-custom="exp-filter-top"] .side-nav-link'
  );
  const filterBlock = element.querySelector(".vertical-filter-block");
  const plusIconLine = element.querySelector(".plus-line.vertical");

  gsap.set(filterBlock, { height: "auto" });

  let filterItemBtn = filterBlock.querySelector(
    ".checkbox-filter-item.is--top"
  );
  let filterItemHeight;
  let filterBlockHeight;
  if (filterItemBtn) {
    filterItemHeight = filterItemBtn.offsetHeight;
    let filterItemBottomMargin = parseInt(
      window.getComputedStyle(filterItemBtn).marginBottom
    );

    filterBlock.querySelector(".checkbox-filter-item.is--top").style
      .marginBottom;
    filterBlockHeight = filterItemHeight * 2 + filterItemBottomMargin * 2;
  }

  // Keep a reference to the animation on the expandFilterBtn item itself
  const tween = gsap
    .timeline()
    .from(filterBlock, {
      height: filterBlockHeight,
      duration: 0.5,
      ease: "power1.inOut"
    })
    .to(plusIconLine, { duration: 0.5, rotation: -90, ease: "none" }, 0)
    .to(expandFilterBtnText, { text: "Voir Moins", duration: 0.1 }, 0)
    .reverse();

  expandFilterBtn.animation = tween;
  animations.push(tween);
}

// // ########################################
// // !!!! BEGIN top filter functionality

// // add active class on click
// let topFilterItems = document.querySelectorAll(".checkbox-filter-item.is--top");

// topFilterItems.forEach((filterItem) => {
//   filterItem.addEventListener("click", () => {
//     if (filterItem.classList.contains("is--active")) {
//       filterItem.classList.remove("is--active");
//     } else {
//       filterItem.classList.add("is--active");
//     }
//   });
// });

// // click corresponding

// const topFilter = document.querySelector('[data-filter-top="true"]');
// const leftFilter = document.querySelector('[fs-cmsfilter-element="filters"]');

// const topFilterBlocks = topFilter.querySelectorAll("[data-hid-top]");
// const hiddenFilterBlocks = leftFilter.querySelectorAll("[data-hid-left]");

// topFilterBlocks.forEach((topFilterBlock) => {
//   topFilterBlock.addEventListener("click", (e) => {
//     let clickTargetAttValue = e.target
//       .closest("[data-hid-top]")
//       .getAttribute("data-hid-top");
//     let clickTargetContent = e.target.textContent;

//     hiddenFilterBlocks.forEach((hiddenFilterBlock) => {
//       let hiddenTargetAttValue = hiddenFilterBlock.getAttribute(
//         "data-hid-left"
//       );

//       if (clickTargetAttValue === hiddenTargetAttValue) {
//         let filterItemsArray = Array.from(hiddenFilterBlock.children);
//         filterItemsArray.forEach((item) => {
//           let hiddenTargetContent = item.textContent;
//           console.log(`Hidden target content: ${hiddenTargetContent}`);
//           console.log(`Click target content: ${clickTargetContent}`);
//           if (hiddenTargetContent === clickTargetContent) {
//             item.click();
//           }
//         });
//       }
//     });
//   });
// });

// // !!!! End top filter functionality

// ########################################
// !!!! BEGIN left filter expand animations

const leftFilterGroups = gsap.utils.toArray(".left-filter-block-group");
const expandLeftFilterTriggers = gsap.utils.toArray(
  '[data-custom="exp-filter-left"]'
);
const leftFilterAnimations = [];

leftFilterGroups.forEach((leftFilterGroup) =>
  createLeftFilterAnimation(leftFilterGroup)
);

expandLeftFilterTriggers.forEach((leftFilterBtn) => {
  leftFilterBtn.addEventListener("click", () =>
    toggleLeftFilterExpandAnimation(leftFilterBtn)
  );
});

function toggleLeftFilterExpandAnimation(expandFilterBtn) {
  // Save the current state of the clicked animation
  const selectedReversedState = expandFilterBtn.animation.reversed();

  // Play animation only for the name clicked on
  expandFilterBtn.animation.play();

  // Set the reversed state of the clicked accordion element to the opposite of what it was before
  expandFilterBtn.animation.reversed(!selectedReversedState);
}

function createLeftFilterAnimation(element) {
  const expandFilterBtn = element.querySelector(
    '[data-custom="exp-filter-left"]'
  );
  const filterBlock = element.querySelector(".left-filter-block");
  const downChevron = element.querySelector(".home-hero__chevron-icon");

  gsap.set(filterBlock, { height: "auto" });

  // Keep a reference to the animation on the expandFilterBtn item itself
  const tween = gsap
    .timeline()
    .from(filterBlock, {
      height: 0,
      duration: 0.05,
      ease: "power1.Out"
    })
    .to(downChevron, { duration: 0.3, rotation: -180 }, 0);

  expandFilterBtn.animation = tween;
  leftFilterAnimations.push(tween);
}

// ########################################

// !!!! BEGIN scroll-based animations

gsap.registerPlugin(ScrollTrigger);

// Begin nav/top filters animation
const topFilterWrap = document.querySelector(".top-filter-wrap");
const titleDescTopSection = document.querySelector("#title-desc-top-section");

function setFilterNav() {
  let reduceColNavTl = gsap.timeline({
    defaults: { ease: Power1.easeInOut, duration: 0.65 },
    paused: true,
    scrollTrigger: {
      trigger: ".top-nav-wrapper",
      // markers: true,
      start: "top -0.1%",
      // events: onEnter onLeave onEnterBack onLeaveBack
      toggleActions: "none play none reverse",
      scrub: 2
    }
  });
  // ####

  let animateCollectionUI = gsap.timeline({
    defaults: {},
    paused: true,
    scrollTrigger: {
      trigger: "#first-title",
      // markers: {
      //   startColor: "blue",
      //   endColor: "orange",
      //   fontSize: "18px",
      //   fontWeight: "bold",
      //   indent: 20
      // },
      start: "top 18%",
      // events: onEnter onLeave onEnterBack onLeaveBack
      toggleActions: "play none reverse reverse",
      scrub: 2
    }
  });

  animateCollectionUI
    .to(titleDescTopSection, {
      backgroundColor: "#fffcf6",
      duration: 0.2
    })
    .to(titleDescTopSection, { y: "2em", duration: 0.3 }, "<")
    .to(titleDescTopSection, { opacity: 0, duration: 0.3 }, "<")
    .from("#second-title", { opacity: 0, duration: 0.4 })
    .from("#second-title", { y: "1em", duration: 0.4 }, "<");

  let hideLeftFilters = gsap.timeline({
    defaults: { duration: 0 },
    paused: true,
    scrollTrigger: {
      trigger: ".product-grid-wrap",
      start: "bottom 40%",
      // events: onEnter onLeave onEnterBack onLeaveBack
      toggleActions: "play none reverse reverse",
      scrub: 2
    }
  });

  hideLeftFilters
    .to(".left-filter", { opacity: 0, duration: 0.2 })
    .to(".left-nav", { mixBlendMode: "difference" },"<")
    .to(".left-nav", { zIndex: 21 },"<")
    .to(".left-nav", { display: "flex" },"<")
    .to(".left-nav", { backgroundColor: "transparent" },"<")
    .to(".left-nav", { x: "0%", duration: 0.5, ease: Power1.Out, delay: 2.8 });
}

ScrollTrigger.saveStyles(
  ".left-nav, .left-filter, #second-title, .tb-logo-top, .tb-logo-top-wrap",
  titleDescTopSection
);
ScrollTrigger.matchMedia({
  // desktop
  "(min-width: 992px)": function () {
    setFilterNav();
  }
});

// ################################
// Begin open/close collection text

const colTextTrigger = document.querySelector("[data-col-trig]");
const expandColBtnText = document.querySelector("[data-col-trig] .expand-collection_btn");
const colText = document.querySelector("[data-col-text] p");

gsap.set(colText, { height: "auto" });
let collectionTextAnim = gsap.timeline({
  defaults: { duration: 1.2, ease: "power2.inOut" },
  paused: true,
  reversed: true
});
collectionTextAnim
.fromTo(expandColBtnText, { text: "+", duration: 0.1 },{ text: "-", duration: 0.1 })  
.fromTo(colText, {lineClamp: 4}, {lineClamp: "unset", duration: 0.1}, "<")
  .fromTo(colText,{height: "4.5em"},{height: "auto",duration: 0.8},"<")

  if (colTextTrigger !== null && colTextTrigger !== undefined) {
    colTextTrigger.addEventListener("click", () => {
      collectionTextAnim.reversed() ? collectionTextAnim.play() : collectionTextAnim.reverse();
    });
  }


// End open/close collection text
// ################################

// ################################
// Create materials slider

function materialsSlider() {
  let materialSplide = new Splide(".splide.materials-slider", {
    // Desktop on down
    perPage: 1,
    perMove: 1,
    focus: 0, // 0 = left and 'center' = center
    type: "slide", // 'loop' or 'slide'
    gap: "4em", // space between slides
    arrows: "slider", // 'slider' or false
    drag: false,
    pagination: false, // 'slider' or false
    speed: 1000, // transition speed in miliseconds
    easing: "cubic-bezier(.645, .045, .355, 1)",
    dragAngleThreshold: 30, // default is 30
    autoWidth: true, // for cards with differing widths
    waitForTransition: false,
    updateOnMove: true,
    trimSpace: false, // true removes empty space from end of list
    flickPower: 200,
    flickMaxPages: 1,
    dragMinThreshold: 70,
    breakpoints: {
      991: {
        // Tablet
        gap: "2em", // space between slides
        drag: true
      },
      767: {
        // Mobile Landscape
        gap: "2em", // space between slides
        drag: true
      },
      479: {
        // Mobile Portrait
        gap: "2em", // space between slides
        drag: true
      }
    }
  });

  materialSplide.on("arrows:mounted", (prev, next) => {
    if (prev.disabled) {
      document.querySelector("[data-my-prev-arrow]").disabled = true;
    }
  });
  materialSplide.mount();

  materialSplide.on("arrows:updated", (prev, next) => {
    if (prev.disabled) {
      disableArrow(myLeftArrow);
    } else {
      enableArrow(myLeftArrow);
    }
    if (next.disabled) {
      disableArrow(myRightArrow);
    } else {
      enableArrow(myRightArrow);
    }
  });
}
materialsSlider();

function instagramSlider() {
  let splides = $(".splide.instagram-slider");
  for (let i = 0, splideLength = splides.length; i < splideLength; i++) {
    new Splide(splides[i], {
      // Desktop on down
      perPage: "auto",
      perMove: 1,
      autoplay: "play",
      focus: 0, // 0 = left and 'center' = center
      type: "slide", // 'loop' or 'slide'
      gap: "2px", // space between slides
      arrows: false, // 'slider' or false
      pagination: false, // 'slider' or false
      speed: 600, // transition speed in miliseconds
      dragAngleThreshold: 30 // default is 30
    }).mount();
  }
}
instagramSlider();

const myArrowsWrap = document.querySelector("[data-my-arrows-wrap]");
const myLeftArrow = document.querySelector("[data-my-prev-arrow]");
const myRightArrow = document.querySelector("[data-my-next-arrow]");

const splideLeftArrow = document.querySelector("[data-splide-prev-arrow]");
const splideRightArrow = document.querySelector("[data-splide-next-arrow]");

myArrowsWrap.addEventListener("click", (e) => {
  if (e.target === myLeftArrow) {
    splideLeftArrow.click();
  }
  if (e.target === myRightArrow) {
    splideRightArrow.click();
  }
});

function disableArrow(arrow) {
  arrow.disabled = true;
}

function enableArrow(arrow) {
  arrow.disabled = false;
}

const desktopMenuBtn = document.querySelector('[data-desk-menu-open]');
const leftNavBg = document.querySelector('[data-left-nav-bg]');

desktopMenuBtn.addEventListener('click', () => {
  leftNav.style.backgroundColor = "#f0ede8";
  leftNav.style.mixBlendMode = "normal"; 
})

leftNavBg.addEventListener('click', (e) => {  
  if (e.target !== innerCart && innerCart.contains(e.target) === false) {
    enableScrollMain.click();
  }
})

function sortColorSwatches() {
  
  // Select the parent element
  const parentElement = document.querySelector('[data-color-swatches]');

  if (!parentElement) return;
  // Set display style of parent to flex
  parentElement.style.display = 'flex';
  parentElement.style.flexDirection = 'column';

  // Get all child div elements in an array
  const childElements = Array.from(parentElement.querySelectorAll('div'));

  // Iterate over each child and set its order
  childElements.forEach((child) => {
    const orderValue = child.getAttribute('data-color-sort');
    child.style.order = orderValue;
  });
}

sortColorSwatches();